import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function CfgLeftCornerChartMove() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Move:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[A -> α X •, i, l]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[A, i, l]</span>
            </div>
        </div>
    </div>)
}
